import { useMutation, useQuery } from '@tanstack/react-query';
import { ComponentProps } from 'preact';

import { Button } from '@/components/Buttons';
import { getProductsQueryOptions, postUserProductMutationFn } from '@/queries/products';
import { ParsedUserProduct, UserProduct } from '@/queries/products/types';
import { trackMP } from '@/shared/mp';

interface PurchaseAgainButtonProps extends ComponentProps<'button'> {
  userProduct: ParsedUserProduct | UserProduct;
}

const PurchaseAgainButton = ({ userProduct }: PurchaseAgainButtonProps) => {
  const { data: activeProduct } = useQuery({
    ...getProductsQueryOptions({
      lookupKey: userProduct.product?.productLookupKey,
    }),
    select: (data) => data.list[0],
    enabled: !!userProduct.product?.productLookupKey,
  });

  const { mutate: checkout, isPending } = useMutation({
    mutationFn: postUserProductMutationFn,
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });

  if (!activeProduct) {
    return null;
  }

  return (
    <Button
      size="lg"
      disabled={isPending}
      className="px-5 py-3 text-base/none"
      onClick={() => {
        checkout({
          productId: activeProduct._id,
          priceId: activeProduct.price.priceId,
          associatedHabitatIds: userProduct.associatedHabitatIds,
        });
        trackMP('request-checkout', {
          productId: activeProduct._id,
          priceId: activeProduct.price.priceId,
          productLookupKey: activeProduct.productLookupKey,
          associatedHabitatIds: userProduct.associatedHabitatIds,
          entryPoint: 'purchase-again',
        });
      }}
    >
      {userProduct.productKind === 'single-use' ? 'Purchase Again' : 'Subscribe Again'}
    </Button>
  );
};

export default PurchaseAgainButton;
